export enum PodcastType {
  EDNCAST = 'EDNCAST',
  ECOCAST = 'ECOCAST',
}
